export default __webpack_public_path__ + "static/media/limbo_boy_2.7ccd3ec8.jpg";